// src/app/interceptors/spinner.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpContextToken,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SpinnerService } from './utilities/services/SpinnerService';

// HttpContextToken para indicar que una petición debe saltarse el spinner.
// No se envía por red, por lo que evita problemas CORS.
export const SKIP_SPINNER = new HttpContextToken<boolean>(() => false);

export const spinnerInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const spinner = inject(SpinnerService);
  // Consultar el contexto de la petición (no enviado por red)
  const shouldSkipSpinner = req.context.get(SKIP_SPINNER) === true;

  if (!shouldSkipSpinner) {
    spinner.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!shouldSkipSpinner) {
        spinner.hide();
      }
    })
  );
};
